/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import PeopleIcon from 'Components/common/assets/svgIcons/PeopleIcon';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import NavBarPrimary, { chatActions, chatStates } from 'Components/layout/headers/NavBarPrimary';
import Title from 'Components/common/components/Title';
import DrawerPeopleBrowse from 'Components/people/components/DrawerPeopleBrowse';
import {
  Row, Col, Button, Modal, notification,
} from 'antd';
import styled from 'styled-components';
import FilterPopOver from 'Components/common/components/FilterPopOver';
import FeedTabs from 'Components/common/tabs/Tabs';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import HighLightsTab from 'Components/person/components/HighLightsTab';
import PencilIcon from 'Components/common/assets/svgIcons/PencilIcon';
import DeleteIcon from 'Components/common/assets/svgIcons/DeleteIcon';
import BuyerColumn from 'Components/people/components/BuyerColumn';
import { PersonProps } from 'Components/common/components/PeopleCardLarge';
import { actions as groupActions } from 'Slice/GroupsSlice';
import { actions as buyerGroupsActions } from 'Slice/BuyerGroupsPageSlice';
import {
  useDispatch, useSelector,
} from 'react-redux';
import {
  selectBuyersHighlights,
  selectMembers,
  selectMembersFilters,
  selectMembersLoading,
  selectPeopleRemovedFlag,
  selectTitleUpdateLoadingForce,
  selectTopPeople,
  selectTopPeopleLoading,
  selectAddRemovePersonInGroup,
  selectGroupDeleted,
  selectPersonRemoved,
  selectBuyersHighlightsLoading,
  selectTotalMembers,
  selectAnalyzeBuyer,
  selectShowGroupNotes
} from 'Selector/BuyerGroupSelector';
import { selectFollowLoading } from 'Selector/PeopleFollowSelector';
import {
  useEffect, useState,
} from 'react';
import {
  BuyersHighlights, SelectedGroupCategory, TopGroupPeopleData, TopPeople,
} from 'Types/BuyerGroupsPageTypes';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import { actions as flurryActions } from 'Slice/HelperSlice';
import {
  allValueInKeyOfArrayExists, anyValueInKeyOfArrayExists,
  IsMobile,
  IsTablet, certificationSmoothBehavior, valueToObject, getCurrentTime,
  // IsMobileSm400,
  formatNumberWithCommas,
  isFreeUser,
} from 'Utils/UtilityFunctions';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import { Filter } from 'Types/FilterTypes';
import { usePrevious } from 'Utils/hooks/usePrevious';
import { actions as peopleFollowActions } from 'Slice/PeopleFollowSlice';
import { actions as globalSearchResultsActions } from 'Slice/GlobalSearchResultsSlice';
import classNames from 'classnames';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import BuyerPersonSkeleton from 'Components/common/skeleton/BuyerPersonSkeleton';
import { Waypoint } from 'react-waypoint';
import {
  globalSearchOpen, isShowGilroyGlobal, selectIsPersonDrag, selectViewTab,
} from 'Selector/UISelector';
import AddReasonPopup from 'Components/common/modal/AddReasonPopup';
import {
  DEFAULT_GROUP_GILROY_IMAGE, GROUP_TOASTER, HIGHLIGHTS, MEMBERS, PEOPLE_ROUTE,
  translateSkipAreas,
} from 'Utils/Constants';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import GlobalButton from 'Components/common/components/GlobalButton';
import ExportIcon from 'Components/common/assets/svgIcons/ExportIcon';
import {
  selectActivetype,
  selectAiCertificationData,
  selectData, selectHighlight, selectIsHighlighted,
  selectIsScroll, selectScrollToId, selectScrollToPage, selectToasterFlag,
} from 'Selector/CertificationSelector';
import CrossCircle from 'Components/common/assets/svgIcons/CrossCircle';
import Cross from 'Components/globalSearch/assets/Cross';
import ShareGroupPeopleModal from 'Components/common/modal/ShareGroupPeopleModal';
// import LayoutIcon from 'Components/common/assets/svgIcons/LayoutIcon';
import { selectGroupShared } from 'Selector/GroupsSelector';
import { ViewInterface } from 'Types/GlobalTypes';
import {
  selectCompanyDetailFlurry, selectCompanyDetailsCall,
} from 'Selector/CompaniesSelector';
import { actions as UiAction } from 'Slice/UISlice';
import { selectDisclessPersonality, selectShowChatbot, selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import { TagItem } from 'Types/ChatBotV2Types';
// import FilterCompanySortBy from 'Components/common/components/FilterCompanySortBy';
// import ConfigurationIcon from 'Components/common/assets/svgIcons/ConfigurationIcon';
import MembersTabV2 from 'Components/person/components/MembersTabV2';
import LayoutIcon from 'Components/common/assets/svgIcons/LayoutIcon';
import { useGilroy } from 'Utils/hooks/useGilroy';
import { Gilroy } from 'gilroy-global';
import { actions } from '../../Slice/BuyerGroupsPageSlice';
import { actions as helperActions } from '../../Slice/HelperSlice';
import {
  primaryFont, wMedium, wLight, secondaryFont,
  primaryHeadingColor, wMBold, maxWidth,
  retina, boxShadow, wBold, minWidthApp, primaryColor,
  maxTablet, maxMobile, scrollbarTransparent,
  peopleCardLargeMinImage, peopleCardLargeMinHolo, SecondaryColor, midTablet, smMobile, minTablet,
  smMobile400,
  white,
  wMLight,
  minStandardScreen,
} from '../../Utils/utilsStyle';
import MergeGroupIcon from 'Components/common/assets/svgIcons/MergeGroupIcon';
import DrawerPeopleMoveReason from '../../Components/people/components/DrawerPeopleMoveReason';
import AnalyzeBuyersIcon from '../../Components/common/assets/svgIcons/AnalyzeBuyersIcon';
import SharedBadge from '../../Components/common/components/SharedBadge';

const Wrapper = styled.div`
.export-people {
  @media all and (max-width: ${maxTablet}){
    width: unset !important;
  }
  .export_btn {
    margin-left: 8px;
    height: 32px;
    @media all and (max-width: ${maxTablet}){
      margin-left: 6px;
      padding: 0 !important;
      font-size: 0 !important;
    }
    svg {
      width: 17px;
      min-width: 17px;
      margin-right: 0px;
      @media all and (${retina}) {
        width: 14px;
        min-width: 14px;
      }
      @media all and (max-width: ${maxTablet}){
        margin-right: 0;
      } 
    }
  }
   @media all and (max-width: ${maxTablet}){ 
    width: 30px;
    .export_btn {
      width: 31px;
      height: 28px;
      padding: 0px 9px;
      svg {
        width: 14px;
        min-width: 14px;
      }
    }
    }
}
  .right-side-wrap{
    .editControlInHeaderWrapper{
      display: flex;
      align-items: center;
      margin-left: 13px;
      .btnEditDelete,
      .btnCancel{
        height: 36px;
        @media screen and (max-width: ${maxWidth}), ${retina} {
          height: 30px;
        }
      }
      .btnEditDelete{
        gap: 0px;
        svg{
          width: 14px;
        } 
        @media screen and (max-width: ${maxWidth}), ${retina} {
          svg{
            width: 12px;
          } 
        }
      }
    }
  }
  .tablet-row-scroll-div {
    @media all and (max-width: ${maxTablet}) {
      ${scrollbarTransparent};
      overflow-x: scroll;
      flex-flow: unset;
      .tablet-column {
        flex: 0 0 150px !important;
        min-width: 150px !important;
      } 
    }
  }
  .title-wrapper-c {
    max-width: 700px;
    @media all and (max-width: ${minWidthApp}) {
      max-width: 300px;
    }
    .people-icon {
      min-width: 23px;
    }
  }
  .shared {
    margin-left: 10px;
    background-color: ${SecondaryColor};
    color: #FFFFFF;
    display: flex;
    height: 22px;
    padding: 4px 8px;
    border-radius: 24px;
    align-items: center;
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 10px;
    line-height: 11px;
    margin-top: 5px;
    @media all and (max-width: ${maxMobile}) {
      margin-left: 0px;
      margin-top: 8px;
    }
    svg {
      height: 10px;
      width: 22px;
      min-width: 22px;
    }
  }
  .share-drawer-div {
    display: flex;
    align-items: flex-start;
    @media all and (max-width: ${maxMobile}) {
      justify-content: flex-end;
      margin-top: -20px;
    }
    .chat-bot-styled-wrapper {
      margin-top: 0px;
      @media all and (${retina}) {
        margin-top: -3px;
      }
      .wrapper-btn {
        margin-top: -1px;
        @media all and (${retina}) {
          margin-top: 3.5px;
        }
        .gilroy-img-gpt {
          height: 75px;
          width: 75px;
          margin-top: -20px;
          @media all and (${retina}) {
           margin-top: -21px;
          }
          @media all and (max-width: ${maxMobile}){
            height: 50px;
            width: 50px;
            margin-top: -11px;
          }
        }
        .btn-chatGpt-drawer {
          height: 35px;
          margin-right: 8px;
          padding: 9px 13px 8px 22px;
          font-size: 13px;
          @media all and (${retina}) {
            height: 33px;
          }
          @media all and (max-width: ${maxMobile}){
            height: 30px;
            margin-right: 0px;
          }
        }
      }
    }
  }
  .peopleGroupHeader {
    z-index: 4;
  }
  h4.sub-title{
    margin-top:20px;
    margin-bottom:8px;
    color:#67696A;
    font-size:18px;
    font-family:${primaryFont};
    font-weight:${wMedium};
    @media all and (max-width: ${maxTablet}) {
      font-size: 16px;
    }
    @media all and (max-width: ${maxMobile}) {
       margin-top: 10px;
     }
   }
   .share-member-div {
    @media all and (max-width: ${maxMobile}) {
      justify-content: flex-end;
      margin-top: 10px;
      margin-right: 8px;
    }
   }
   .sub-title-share-add-div {
     @media all and (max-width: ${maxMobile}) {
       div {
         &:first-child {
           margin-right: 8px;
         }
       }
       .share-button-group {
         padding: 7px 12px 3px;
         .icon-mode {
           .shareIcon-svg {
             height: 16px;
           }
         }
       }
     }
  }
  .white-wrapper-buyer{
    border-radius:16px;
    background-color:#fff;
    padding:30px 24px 50px 24px;
    height: 100%;
    @media all and (${retina}) {
      padding: 18px 10px 25px 10px;
    }
    .ant-col {
      .grabber {
        width: 100%;
      }
    }
    .box-title{
      color:#3F4B50;
      font-size:18px;
      font-family:${primaryFont};
      font-weight:${wMedium};
      text-align:center;
      margin-bottom:26px;
      @media all and (${retina}) {
        font-size: 14px;
      }
      .icon-area{
        float: right;
        cursor: pointer;
        svg {
          @media all and (${retina}) {
            width: 14px;
          }
        }
      }
    }
    .person-item{
      margin-bottom:5px;
      .person-item-widget {
        .name-wrapper {
          cursor: auto;
          bottom: -8px;
          margin-left: 3px;
          @media all and (${retina}) {
           bottom: -3px;
          }
          @media all and (max-width: ${minWidthApp}) {
           bottom: -5px;
          }
          h4 {
            margin: 2px;
            @media all and (${retina}) {
             bottom: 5px;
            }
          }
        }
      }
      .person-name-here {
        margin-top: 16px;
        @media all and (${retina}) {
          margin-top: 0px;
        }
      }
    }
  }
  .hover-general-popover{
    max-width:220px;
    /* top: 52px !important; */
    .ant-popover-arrow{
      width: 16px;
      height: 16px;
      right:5px;
      .ant-popover-arrow-content{
        width: 16px;
        height: 16px;
        background-color: ${white};
        &:hover{
          width: 16px;
          height: 16px;
        }
      }
    }
    .ant-popover-inner-content{
      padding:20px 42px 10px 16px;
      .label-popover{
        color:#000000;
        font-size:14px;
        font-weight:${wLight};
        font-family:${primaryFont};
        margin:0 0px 25px 0;
        width: 200px;
        line-height:20px;
        @media all and (${retina}) {
          font-size: 14px;
        }
      }
      ul{
        margin:0;
        padding:0;
        list-style: none;
        li{
          margin:0 0 12px 10px;
          padding-left:8px;
          font-size:14px;
          font-weight:${wLight};
          font-family:${primaryFont};
          color:#0D0D0D;
          line-height: 18px;
          @media all and (${retina}) {
            font-size: 12px;
          }
          &::before {
            content: "";
            color: #7A7A7A;
            font-weight: bold;
            display: inline-block;
            width: 8px;
            height:8px;
            margin-left: -16px;
            background-color:#7A7A7A;
            border-radius:50%;
            margin-right: 8px
          }
        }
      }
    }
  }
  .topPeople_wrapper{
    background-color: #fff;
    box-shadow: ${boxShadow};
    border-radius: 16px;
    padding: 30px 20px;
    margin: 10px 0px; 
    position: relative;
    @media all and (max-width: ${maxMobile}) {
      padding: 30px 5px;
      margin: 0px 0px !important;
    }
    .person-item {
      margin-bottom: 0px;
      .person-item-widget {
        .name-wrapper {
          cursor: auto;
        }
        @media all and (max-width: 1440px){
          width: 140px;
          min-width: 140px;
          height: 140px;
        }
        @media all and (max-width: ${minWidthApp}) {
          ${peopleCardLargeMinImage}
        }
        .holo-svg {
          @media all and (max-width: 1440px){
            width: 133px;
            height: 126px;
          } 
          @media all and (max-width: ${minWidthApp}) {
            ${peopleCardLargeMinHolo}
          }
        }
        .image-wrap-placeholder {
          @media all and (max-width: 1440px){
            transform: translate(-54.5%,-53.5%);
          }
          @media all and (max-width: ${minWidthApp}) {
            transform: translate(-52.5%,-52.5%);
          }
        }
        .name-wrapper {
          @media all and (max-width: 1440px){
            bottom: -5px;
          }
          h4 {
            @media all and (max-width: 1440px){
              margin: 2px;
            }
          }
        }
      }
    }
    .person-skeleton-loader {
      margin: 0px 18px 50px 18px !important;
    }
  }
  .drag-appeaser{
    .person-item {
      .person-item-widget {
        .name-wrapper {
          cursor: auto;
          bottom: 0;
          @media all and (${retina}) {
           bottom: 0;
          }
          h4 {
            margin: 2px;
            @media all and (${retina}) {
             bottom: 0;
            }
          }
        }
      }
    }
  }
  .search-distance-row {
    margin: 0 !important;
  }
  &.layerActive {
    .ant-layout-header {
      z-index: 5;
    }
    .buyers-category{
      z-index: 3;
      &.availDrop {
        z-index: 1;
      }
    }
    .boxDoor {
      z-index: 3;
    }
    .membersTabWrapper{
      .row1{
        z-index: 1 !important;
      }
    }
  }
  .group-details-pills {
    @media all and (max-width: ${maxMobile}) {
     flex-direction: column;
     align-items: flex-start;
    }
  }
  .boxDoor {
    z-index: 2;
    @media all and (max-width: ${maxMobile}) {
      top: 200px;
     }
   }
   .sub-navbar-group-detail {
      align-items: center;
      @media all and (max-width: ${maxMobile}) {
        align-items: flex-start;
      }
      .header-main-wrapper{
        @media all and (max-width: ${maxMobile}) {
          min-height: unset;
        }
      }
     .sub-navbar-left-side {
       .title-wrapper-c {
          padding-left: 55px;
          min-height: 36px;
          @media all and (max-width: ${minStandardScreen}){
            padding-left: 0;
          }
          @media all and (${retina}) {
            min-height: unset;
            }
          @media all and (min-width: ${maxMobile}) and (max-width: ${minTablet}){
            max-width: 250px;
          }
          @media all and (max-width: ${maxMobile}){
            min-height: 30px;
          }
          .title-style{
            color: ${primaryHeadingColor};
            font-family: ${secondaryFont};
            font-size: 22px;
            font-style: normal;
            font-weight: ${wMBold};
            line-height: 36px;
            letter-spacing: -0.75px;
            @media all and (max-width: ${minStandardScreen}) {
              font-size: 22px;
              line-height: 29px;
              letter-spacing: -0.6px;
            }
            @media all and (max-width: ${maxMobile}) {
              font-size: 16px;
              line-height: 27px;
              letter-spacing: -0.5px;
              max-width: 280px;
            }
            @media all and (max-width: ${smMobile}) {
              max-width: 97px;
            }
          }
         .people-icon {
            @media all and (max-width: ${minStandardScreen}) {
              width: 22.001px;
              height: 18.906px;
              margin-right: 8.8px;
            }
            @media all and (max-width: ${maxMobile}) {
              width: 20.627px;
              height: 17.725px;
              margin-right: 8px;
            }
         }
         .editable {
           @media all and (max-width: ${maxMobile}) {
             left: 18px;
           }
           .editable-inner {
             top: 0px;
             @media all and (${retina}) {
               top: unset;
             }
             @media all and (min-width: ${maxTablet}) and (max-width: 1180px) {
               width: 370px;
             }
             @media all and (max-width: ${midTablet}) {
               width: 250px;
             }
             @media all and (min-width: 767px) and (max-width: 810px) {
              width: 210px;
             }
             @media all and (max-width: ${smMobile}) {
               width: 200px;
             }
             input{
              @media all and (min-width: 767px) and (max-width: 1040px) {
                left: 0px;
                font-size: 13px;
              }
              @media all and (max-width: 767px) {
                left: 24px;
                font-size: 12px;
              }
             }
            .cross {
              @media all and (max-width: 1040px) {
                right: 35px;
              }
              @media all and (max-width: 767px) {
                right: 15px;
              }
            }
            .tick {
              @media all and (max-width: 1040px) {
                right: 10px;
              }
              @media all and (max-width: 767px) {
                right: -10px;
              }
    }
           }
         }
       }
       @media all and (max-width: ${maxMobile}) {
         width: calc(100% - 130px);
         justify-content: center;
       }
     }
     .sub-navbar-right-side {
      @media all and (max-width: ${maxMobile}) {
        display: flex;
        flex-direction: column;
        margin-top: 5px;
        .chat-bot-styled-wrapper {
          margin: 0px;
        }
      }
      .chatbot-v2-global-btn{
        .wrapper-btn{
          margin-top: -1px;
          @media all and (${retina}) {
            margin-top: 0;
          }
          .gilroy-img-gpt {
            width: 80px;
            height: 80px;
            margin-top: -23px;
            margin-bottom: -23px;
            @media all and (${retina}) {
              width: 75px;
              height: 75px;
            }
          }
          .btn-chatGpt-drawer{
            height: 35px;
            @media all and (${retina}) {
              height: 33px;
            }
          }
        }
      }
      .chat-bot-styled-wrapper {
      @media all and (max-width: ${maxTablet}) {
        margin-right: 5px;
      }
      }
      .share-button-group {
        @media all and (${retina}) {
          padding: 8px 12px 6px 12px;
        }
        .icon-mode {
          .icon-mode-text {
            font-size: 14px;
            font-weight: ${wMedium};
          }
          .seperator {
            @media all and (${retina}) {
              height: 14px;
            }
          }
          .share-icon {
            .shareIcon-svg {
              @media all and (${retina}) {
                height: 16px;
              }
            }
          }
        }
      }
      .modal-addMember-group {
        position: relative;
      }
      &.share-drawer-div{
        & > div{         
          height: 32px;
          gap: 8px;
          @media all and (max-width: ${minStandardScreen}) {
            height: 30px;
          }
          & > div{
            .modal-addMember-group{
              border-radius: 6px;
              font-size: 12px;
              line-height: 16px;
            }
            .share-button-group{
              height: 100% !important;
              border-radius: 6px;
              display: flex;
              align-items: center;
              @media all and (max-width: ${maxMobile}) {
                padding: 0px !important;
                width: 30px;
                height: 26px !important;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 0px;
              }
              .icon-mode{
                align-items: center;
                .icon-mode-text{
                  @media all and (max-width: ${minStandardScreen}) {
                    font-size: 12px;
                    line-height: 16px;
                  }
                }
                .shareIcon-svg{
                  margin-top: 3px;
                }
              }
            }
          }
        }
      }
    }
  }
  .container {
    &.bottomAccordion {
      .chatbot-v2 {
        margin-bottom: 200px;
      }
    }
    &.chatbot-container {
      /* padding-bottom: 5px; */
      /* @media all and (max-width: ${maxTablet}) {
        padding-bottom: 20px;
      } */
      .boxDoor {
       @media all and (max-width: ${maxTablet}) {
         display: none;
       }
      }
    }
    .chatbot-v2 {
      @media all and (${retina}) {
        margin-bottom: 0px;
      }
    }
    .feed-tabs-div{
      @media screen and (max-width: ${maxMobile}) {
        margin-bottom: 16px;
      }
      .tips-placeholder{
        .tabs-wrapper{
          .tabs-item{
            @media screen and (max-width: ${maxMobile}) {
              padding: 0 16px;
              height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              line-height: 16px;
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
`;

const TabsWrapper = styled.div`
  .filter-placeholder{
    .spin-tablet {
      height: 32px;
      .ant-spin-dot {
        font-size: 17px;
      }
    }
    .filterPeopleGroup {
      .filter-text{
        margin-left: 8px !important;
        margin-right: 0 !important;
        @media all and (max-width: ${maxWidth}), ${retina} {
          font-size: 14px;
        }
      }
      .resolution-filter-popover{
        @media all and (max-width: ${minWidthApp}) {
          margin: 0 !important;
        }
        @media all and (max-width: ${maxTablet}) {
          margin-left: 6px !important;
        }
      }
    }
    @media all and (max-width: ${maxTablet}) {
      justify-content: flex-end;
      .filterPeopleGroup {
        .tabs-wrapper {
          .tabs-item {
            width: 35px !important;
            height: 32px !important;
            padding: 0px;
            .filter-icon-dropdown {
              min-width: 14px;
              width: 14px;
              height: 20px;
              margin-left: 2px;
              margin-top: 2px;
            }
            &.spin-tablet {
              background-color: #FFFFFF;
              border-radius: 8px !important;
              border: 1px solid #DADADA;
              padding: 4px;
              .ant-spin-spinning {
                margin-top: 1px;
                margin-left: 2px;
                .ant-spin-dot {
                  font-size: 17px;
                }
              }
            }
          }
        }
      }
    }
    @media all and (max-width: ${maxMobile}) {
      .filterPeopleGroup {
        .tabs-wrapper {
          .tabs-item {
            width: 30px !important;
            height: 26px !important;
            min-height: 26px !important;
            padding: 0px;
          }
        }
      }
    }
  }
  &.tabs-placeholder {
    .filter-tabs-heading-row {
      display: flex;
      align-items: center;
      margin-left: 0 !important;
      margin-right: 0 !important;
      .tablet-col-search{
        @media screen and (max-width: ${smMobile400}) {
          margin-top: 0 !important;
        }
      } 
      & > div {
        display: flex;
        flex: 1;

        &.feed-tabs-div {
          padding-left: 55px;
          justify-content: center;
          @media all and (max-width: ${minStandardScreen}){
            padding-left: 42px;
          }
        }
      }
    }
    .tabs-wrapper {
      .tabs-item {
        &.edit-tab {
          @media all and (max-width: ${maxTablet}) { 
            width: 35px !important;
            height: 32px !important;
            min-height: 32px !important;
            padding: 7px;
          }
          @media all and (max-width: ${maxMobile}) { 
            width: 30px !important;
            height: 26px !important;
            min-height: 26px !important;
          }
          span{
            margin-right: 0 !important;
            margin-left: 0 !important;
            @media all and (max-width: ${maxWidth}), ${retina} {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .feed-tabs-div{
    @media all and (max-width: ${maxTablet}) { 
      .tips-placeholder {
        margin-left: 0px;
        .tabs-wrapper {
          .tabs-item {
            margin-left: 0px;
            margin-right: 6px;
            padding: 8px 15px;
          }
        }
      }
    }
  }
  .tablet-col-search {
    @media all and (max-width: ${maxMobile}) { 
      display: none;
    }
    &.showOnlyMembersHere {
      @media all and (max-width: ${maxMobile}) { 
        display: block;
      }
    }
    @media all and (max-width: ${smMobile400}) { 
      margin-top: 15px;
    }
    @media all and (max-width: ${maxTablet}) {
      .other-div {
        .icon-mode {
          margin-right: -4px;
          margin-top: -3px;
          .ant-input-prefix {
            svg {
              height: 18px;
            }
          }
        }
        .cancel-icon-mode {
          margin-left: 10px;
          width: 30px;
          min-width: 30px;
          height: 28px;
          padding: 0px !important;
          svg {
            path {
              fill: #7E7E7E;
            }
          }
        }
      }
    }
  }
  &.tabs-placeholder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    margin-bottom: 25px;
    @media screen and (max-width: ${maxMobile}) {
     margin-bottom: 12px;
    }
    .headingContent{
      .head-wrap {
        padding-left: 55px;
        margin-right: 0;
        margin-right: auto;
        font-family: ${primaryFont};
        font-size: 24px;
        font-weight: ${wMedium};
        color: ${primaryHeadingColor};
        white-space: pre;
        display: flex;
        align-items: center;
        line-height: 36px;
        letter-spacing: -0.75px;
        @media all and (${retina}) {
          font-size: 20px;
        }
        @media all and (max-width: ${minStandardScreen}){
          padding-left: 0;
          font-size: 18px;
          line-height: 28px;
          letter-spacing: -0.6px;
        }
        @media all and (max-width: ${maxTablet}) {
          font-size: 16px;
        }
        @media all and (max-width: ${maxMobile}) {
          font-size: 14px;
          line-height: 16px;
          letter-spacing: -0.525px;
        }
        .heading-div {
          display: flex;
          align-items: center;
        }
        .count {
          /* font-size: 20px;
          display: inline-block;
          @media all and (${retina}) {
           font-size: 15px;
          } */
        }
        .layerAppend {
          font-family: ${primaryFont};
          font-style: normal;
          font-weight: ${wMLight};
          font-size: 18px;
          margin-top: 0px;
          line-height: 34px;
          color: #67696A;
          letter-spacing: -0.375px;
          margin-left: 10px;
          .green {
            color: ${primaryColor};
          }
          @media all and (max-width: ${minStandardScreen}) {
            font-size: 15px;
            line-height: 28px;
          }
          @media all and (${retina}) {
            font-size: 18px;
          }
          @media all and (max-width: ${maxTablet}) {
            font-size: 13px;
          }
        }
      }
    }
    .filter-placeholder{
      .tabs-item,
      .export_btn{
        height: 32px;
        min-height: 32px;
        border-radius: 6px !important;
        padding: 0px 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: 16px;
        letter-spacing: -0.4px;
        @media screen and (max-width: ${minStandardScreen}){
          font-size: 12px;
          line-height: 16px;
        }
        @media all and (max-width: ${maxTablet}) { 
          width: 35px !important;
          height: 32px !important;
          min-height: 32px !important;
        }
        @media all and (max-width: ${maxMobile}) { 
          width: 30px !important;
          height: 26px !important;
          min-height: 26px !important;
        }
      }
    }
    .filter-placeholder{
      .tabs-item{
        gap:0px;
        span{
          @media screen and (max-width: ${maxWidth}) , ${retina} {
            font-size: 14px !important;
          }
          @media screen and (max-width: ${minStandardScreen}) {
            font-size: 12px !important;
          }
        }
      }
    }
    .feed-tabs-div{
      .tabs-wrapper{
        gap: 12px;
        .tabs-item{
          margin-right: 0 !important;
          margin-left: 0;
          height: 32px;
          min-height: 32px;
          border-radius: 6px !important;
          padding: 0px 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: ${primaryFont};
          font-size: 14px;
          font-weight: ${wMedium};
          line-height: 16px;
          letter-spacing: -0.4px;
          @media screen and (max-width: ${minStandardScreen}){
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
    }
    .filter-placeholder {
        margin-left: auto;
        min-width: 150px;
        .ant-popover{
          z-index: 3;
        }
        .tabs-item {
          margin-right: 0px;
          padding: 0px 16px;
          > svg {
            @media all and (max-width: ${maxTablet}) {
              height: 17px;
              width: 17px;
            }
            @media all and (max-width: ${maxWidth}) {
              width: 14px;
            }
            width: 14px;
            margin-right: 0px;
            margin-top: 0px;
          }
        }
    }
  }

  .large-mode {
    > div, .input-dropdown-wrapper {
      height: 100%;
    }
  }
  .search-field {
    height: 100%;
  }
  .clear-search {
    &.crossVisible {
      top: 11px;
    }
  }
  .tabs-item {
    margin-left: 8px;
    cursor: pointer;
    &.svg-style {
      svg {
        margin-right: 8px;
        vertical-align:middle;
      }
    }
  }
  .edit-tab {
    margin-left: 0px;
  }
  /* .highlightActive {
    margin-left: -270px;
  }
  .membersActive {
    margin-left: -145px;
  } */
  .large-mode{
    min-width: 50px !important;
    @media all and (max-width: ${maxTablet}) {
     height: 28px;
    }
  }
  .isEditEnable {
    .filter-icon-dropdown {
      max-width: 20px;
      width: 20px;
      margin-top: 0px;
      margin-left: 2px;
    }
    .tabs-item {
      @media all and (${retina}) { 
       padding: 10px;
      }
      > {
        span {
          display: none;
        }
      }
      svg {
        @media all and (${retina}) {
          margin-top: 2px !important;
        }
      }
    }
  }

`;

export const PeopleNotFound = styled.span`
 font-family: ${secondaryFont};
 font-size: 18px;
 font-weight: ${wMBold};
 display: inline-block;
 width: 100%;
 text-align: center;
 vertical-align: auto;
 margin-top: 8px;
`;
const OverlayLayer = styled.span`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,0.4);
  z-index: 2;
  display: none;
  &.show {
    display: block;
  }
`;
const CustomModal = styled(Modal)`
  .ant-modal-content{
    border-radius: 18px;
    text-align: center;
    .ant-modal-close-x {
      svg {
        margin: 16px 22px 0 0;
      }
    }
    .ant-modal-body{
        padding: 78px 50px 0 50px;
      
      .heading_logout_popup{
        font-family: ${secondaryFont};
        font-size: 30px;
        letter-spacing: -0.8;
        line-height: 40px;
        color: ${primaryHeadingColor};
        font-weight: ${wBold};
        @media all and (max-width: ${maxMobile}) {
          font-size: 22px;
          line-height: 24px;
          margin: 20px 0;
        }
      }
      .text_logout_popup{
        font-family: ${primaryFont};
        font-size: 20px;
        font-weight: ${wLight};
        letter-spacing: -0.56;
      }
    }
    .ant-modal-footer{
      display: flex;
      justify-content: center;
      padding: 50px 50px 48px 50px;
      .ant-btn {
        border-radius: 18px;
        font-family: ${primaryFont};
      }
    }
    .ant-btn-primary{
      color: #1EC252 !important;
      border-color: #1EC252 !important;
      background-color: #ffff !important;
    }
    .ant-btn-default{
      background-color: #1EC252;
      border-color: #1EC252;
      color: #fff !important;
    }
  }
`;

const MergeMobileBtn = styled.div`
  background-color: ${primaryColor};
  width: 30px;
  height: 26px !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  svg {
    width: 12px;
    height: 13px;
  }
`

type TabsInterface = {
  [key: string]: JSX.Element
};

type Params = {
  section: string
};

export const getSkeletonsForPeopleOfGroups = (numberOfPeople = 6) => {
  const people = [];
  for (let i = 0; i < numberOfPeople; i += 1) {
    people.push(
      <Col className="gutter-row d-flex justify-content-center mobile-scroll-col" span={12}>
        <BuyerPersonSkeleton />
      </Col>,
    );
  }
  return people;
};

export const getSkeletonsForGroups = (loading: boolean, isMobile: boolean) => {
  const groups = [];
  const people = getSkeletonsForPeopleOfGroups();
  groups.push(
    [1, 2, 3].map(() => (
      <Col className="gutter-row mb-c-20" span={isMobile ? 24 : 8}>
        <BuyerColumn loading={loading} rowClassName="mobile-scroll-row">
          {people}
        </BuyerColumn>
      </Col>
    )),
  );
  return groups;
};

const PeopleGroupDetail = function PeopleGroupDetail() {
  const { gilroyStates, gilroyActions } = useGilroy();
  const { saveUrl: savedUrlV2 } = chatStates;
  const { section } = useParams<Params>();
  const { pathname } = window.location;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const host = window.location.href;
  const [showStickyNav, setShowStickyNav] = useState<boolean>(true);
  const [navArray, setNavArray] = useState<string[]>([]);
  const [isCompanyDetailsInView] = useState<boolean>(false);

  const topPeopleLoading: boolean = useSelector(selectTopPeopleLoading);
  const topPeople: TopGroupPeopleData | null = useSelector(selectTopPeople);

  const filtersFromRedux = useSelector(selectMembersFilters);
  const titleUpdateLoadingForce = useSelector(selectTitleUpdateLoadingForce);
  const isGlobalSearchOpen: boolean = useSelector(globalSearchOpen);
  const isAddPersonPersonInGroup: boolean = useSelector(selectAddRemovePersonInGroup);
  const previousFiltersFromRedux = usePrevious(filtersFromRedux);

  const [searchParams] = useSearchParams();
  const groupId = searchParams.get('groupId');

  const groupIdParsed = groupId ? parseInt(groupId, 10) : 0;

  const [filters, setFilters] = useState<Filter[]>([]);
  const [apiCheck, setApiCheck] = useState<boolean>(true);
  const [previousFiltersApplied, setPreviousFiltersApplied] = useState<Filter[]>([]);
  const [filtersAppliedOnce, setFiltersAppliedOnce] = useState<boolean>(false);
  const [selectAll, setSelectAll] = useState<boolean>(true);
  const [searchString, setSearchString] = useState<string>('');
  const [editClicked, setEditClicked] = useState(false);
  const [removeClicked, setRemoveClicked] = useState(false);
  const [removedPeople, setRemovedPeople] = useState<number[]>([]);
  const [removedGrpPeople, setRemovedGrpPeople] = useState<SelectedGroupCategory[]>([]);
  const [disableEditLocal, setDisableEditLocal] = useState<boolean>(false);
  const [popupRemoveClicked, setPopupRemoveClicked] = useState(false);

  const members: TopPeople | null = useSelector(selectMembers);
  const peopleRemovedFlag: boolean = useSelector(selectPeopleRemovedFlag);
  const previousPeopleRemovedFlag = usePrevious(peopleRemovedFlag);
  const membersLoading: boolean = useSelector(selectMembersLoading);
  const addRemoveLoading = useSelector(selectFollowLoading);

  const highlights: BuyersHighlights | null = useSelector(selectBuyersHighlights);
  const isPersonDrag: boolean = useSelector(selectIsPersonDrag);
  const groupDeleted: boolean = useSelector(selectGroupDeleted);
  const personRemoved: boolean = useSelector(selectPersonRemoved);
  const isAnalyzeBuyer = useSelector(selectAnalyzeBuyer);
  // const showGroupNotes: boolean = useSelector(selectShowGroupNotes);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [categoryPrev, setCategoryPrev] = useState<string>('');
  const [categoryNext, setCategoryNext] = useState<string>('');
  const [stagePrev, setStagePrev] = useState<string>('');
  const [stageNext, setStageNext] = useState<string>('');
  const [personId, setPersonId] = useState<number>(0);
  const [drag, setDrag] = useState<boolean>(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [drawerToggle, setDrawerToggle] = useState<boolean>(false);
  const previousToggle = usePrevious(drawerToggle) || false;
  const isMob = IsMobile();
  const isTab = IsTablet();
  const tabView: ViewInterface = useSelector(selectViewTab);
  const isListView = tabView.view === 'listView';
  const groupShared = useSelector(selectGroupShared);
  const getMembersTab = window?.location?.pathname?.includes('members');
  const scrollToId: string = useSelector(selectScrollToId);
  const isScroll: boolean = useSelector(selectIsScroll);
  const scrollToPage: string = useSelector(selectScrollToPage);
  const highlightsLoading = useSelector(selectBuyersHighlightsLoading);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isHighlighted = useSelector(selectIsHighlighted);
  const toasterFlag = useSelector(selectToasterFlag);
  const [isToaster, setIsToaster] = useState(toasterFlag);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const flurryObject = useSelector(selectCompanyDetailFlurry);
  const isCalled = useSelector(selectCompanyDetailsCall);
  const currentUrl = window.location.href;
  const startTime = getCurrentTime();
  const showGilroyGlobal = useSelector(isShowGilroyGlobal);
  const chatbotAllowed = useSelector(selectShowChatbot);
  const allowGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const aiCertificationData = useSelector(selectAiCertificationData);
  const membersCount = useSelector(selectTotalMembers);
  const formattedMembersCount = formatNumberWithCommas(membersCount || 0);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };
  const isDrag = (flag: boolean) => {
    setShowNew(false);
    setDrag(flag);
    if (!isPersonDrag) { setOpenCreateModal(flag); }
    if (flag) dispatch(groupActions.setDropComplete(false));
  };

  useEffect(() => {
    window.scroll(0, 0);
    if (highlights?.groupId !== groupIdParsed) {
      setNavArray([]);
      if (currentUrl !== savedUrlV2) {
        dispatch(actions.resetMembers({
          groupId: groupIdParsed,
        }));
        dispatch(actions.resetHighlights({
          groupId: groupIdParsed,
        }));
        dispatch(actions.resetRecommendedPeople());
        dispatch(actions.resetNoGroupMembers());
      }
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
      setFiltersAppliedOnce(false);
      if (editClicked) setEditClicked(false);
      if (removeClicked) setRemoveClicked(false);
      if (searchString) setSearchString('');
    }
    if (currentUrl === savedUrlV2) {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
    return () => {
      if (!window.location.pathname.includes('/groupdetails')) {
        dispatch(groupActions.reset());
        dispatch(actions.resetMembers({}));
        dispatch(actions.resetHighlights({
        }));
        dispatch(actions.resetRecommendedPeople());
        dispatch(actions.resetNoGroupMembers());
        dispatch(actions.resetMembersPageNumber({}));
        dispatch(actions.setGroupDeleted(false));
      }
    };
  }, [groupIdParsed]);

  const onChangeFilters = (flag: boolean, id: string) => {
    const tempFilters = filters.map((filter) => {
      if (filter.filterId === id) {
        return { ...filter, isSelected: flag };
      } return { ...filter };
    });
    setFilters(tempFilters);
    setSelectAll(allValueInKeyOfArrayExists(tempFilters, 'isSelected', true));
    dispatch(actions.resetMembersPageNumber({}));
  };

  const selectOrUnselectAll = (flag: boolean) => {
    const tempFilters = filters.map((filter) => ({ ...filter, isSelected: flag }));
    setFilters(tempFilters);
  };

  const onClickHandler = () => {
    selectOrUnselectAll(!selectAll);
    setSelectAll(!selectAll);
  };

  const applyFilterHandler = () => {
    const selectedFilter = `${filters.filter((item) => item.isSelected).map((item) => item.filterId).join(',')}`;
    dispatch(actions.resetMembersPageNumber({}));
    dispatch(actions.getMembersV2({
      groupId: groupIdParsed,
      filters: selectedFilter,
      filterRequired: 0,
      offset: 0,
      ...searchString.length ? {
        query: searchString,
      } : {},
    }));
    dispatch(actions.setFilterArray({
      title: 'Filters',
      type: 'filters',
      data: filters,
    }));
    setPreviousFiltersApplied(filters);
    if (!filtersAppliedOnce) setFiltersAppliedOnce(true);
    const selectedFilterVal = filters.filter((item) => item.isSelected);
    dispatch(actions.selectedFilter(selectedFilterVal));
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('bgroup_filters_applied', 0, {
        filters: selectedFilter,
        group_id: groupIdParsed,
        host,
      }),
    ));
  };

  const data = useSelector(selectData);

  const removeSelectedPeople = () => {
    setRemoveClicked(true);
    dispatch(peopleFollowActions.updateProfileFollow({
      removedPeople: removedGrpPeople,
      feedids: removedPeople,
      group_id: groupIdParsed,
    }));
  };

  const handleEditClick = () => {
    if (editClicked) {
      removeSelectedPeople();
    } else {
      setEditClicked(!editClicked);
    }
  };

  const isTopPeople = () => topPeople && topPeople.data && topPeople.data.length > 0;

  useEffect(() => {
    if (isApiCalled && !addRemoveLoading && isTopPeople()) {
      dispatch(actions.getTopPeople({
        groupId: groupIdParsed,
      }));
    }
  }, [addRemoveLoading]);

  useEffect(() => {
    dispatch(globalSearchResultsActions.clearSearchText());
  }, [removeClicked, groupId]);

  const getButtonLabel = () => {
    if (editClicked) {
      if (removeClicked) return 'Removing';
      return 'Remove';
    }
    return 'Edit';
  };

  const addRemovePerson = (flag: boolean, id: number, category: string, stage: string) => {
    dispatch(actions.setPersonRemoved(true));
    const removedPerson = {
      category,
      id,
      stage,
    };
    if (flag) {
      setRemovedPeople([...removedPeople, id]);
      setRemovedGrpPeople([...removedGrpPeople, removedPerson]);
    } else {
      setRemovedPeople(removedPeople.filter((peopleId) => peopleId !== id));
      setRemovedGrpPeople(removedGrpPeople.filter((people) => people?.id !== id));
    }
  };

  const handleTitleEdit = (newTitle?: string) => {
    const editGroupName = newTitle?.trim().replace(/  +/g, ' ');
    if (editGroupName !== '') {
      dispatch(actions.editTitleOfGroup({
        groupName: String(editGroupName),
        groupId: groupIdParsed,
      }));
    } else {
      setDisableEditLocal(true);
      dispatch(helperActions.setNotification({
        message: 'Group name cannot be empty.',
        proTip: false,
        rightPlacement: true,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  };

  const checkForApplyFilter = () => {
    for (let i = 0; i < filters.length; i += 1) {
      if (filters[i].isSelected !== previousFiltersApplied[i]?.isSelected) return false;
    }
    return true;
  };

  useEffect(() => {
    if (editClicked && removeClicked && !previousPeopleRemovedFlag && peopleRemovedFlag) {
      setRemoveClicked(false);
      setEditClicked(false);
      setRemovedPeople([]);
      setRemovedGrpPeople([]);
      dispatch(actions.handlePeopleRemovedFlag(false));
    }
  }, [peopleRemovedFlag]);

  useEffect(() => {
    if (filtersFromRedux?.length !== previousFiltersFromRedux?.length) {
      setFilters(filtersFromRedux);
      setPreviousFiltersApplied(filtersFromRedux);
    }
  }, [filtersFromRedux]);

  const getHighlights = (page: number) => {
    dispatch(actions.getHighlights({
      groupId: groupIdParsed,
      page,
    }));
  };

  useEffect(() => {
    if (groupIdParsed && savedUrlV2 !== currentUrl) {
      getHighlights(1);
      setApiCheck(false);
      setIsApiCalled(true);
      dispatch(actions.getTopPeople({
        groupId: groupIdParsed,
      }));
      dispatch(actions.getMembersV2({
        groupId: groupIdParsed,
        filterRequired: 1,
        offset: 0,
        ...searchString.length ? {
          query: searchString,
        } : {},
      }));
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
      dispatch(helperActions.callFlurryEvent(
        valueToObject('buyer_group_open', startTime, {
          group_id: groupIdParsed,
          host,
        }),
      ));
    }
  }, [groupIdParsed]);

  useEffect(() => {
    if (isAddPersonPersonInGroup) {
      getHighlights(1);
    }
  }, [isAddPersonPersonInGroup]);

  const openDrawer = () => {
    setPopupVisible(false);
    setDrawerToggle(!drawerToggle);
    dispatch(actions.setPersonRemoved(false));
  };
  useEffect(() => {
    if (members?.membersCount === 0 && personRemoved && !(anyValueInKeyOfArrayExists(filters, 'isSelected', false) || searchString)) {
      setPopupVisible(true);
    } else if (members?.membersCount === 0 && !personRemoved) {
      openDrawer();
    }
  }, [members]);

  useEffect(() => {
    if (groupDeleted && popupRemoveClicked) {
      navigate(`${PEOPLE_ROUTE}`);
    }
  }, [groupDeleted]);

  const addReasonPopup = (person: PersonProps, category: string, stage: string) => {
    setPersonId(person.personId);
    setVisible(true);
    setCategoryPrev(person?.categoryData?.prevCategory);
    setCategoryNext(category);
    setStagePrev(person?.categoryData?.prevStage);
    setStageNext(stage);
  };

  const handleChangeCategory = (reason: string) => {
    dispatch(actions.changeCategoryV2({
      groupId: groupIdParsed,
      personId,
      categoryPrev,
      categoryNext,
      stagePrev,
      stageNext,
      reasonText: reason,
    }));
  };

  const tabs: TabsInterface = {
    members: <MembersTabV2
      searchString={searchString}
      addRemovePerson={addRemovePerson}
      removedPeople={removedPeople}
      editEnable={editClicked}
      isDrag={isDrag}
      filters={!filtersAppliedOnce ? '' : `${filters.filter((item) => item.isSelected).map((item) => item.filterId).join(',')}`}
      addReasonPopup={addReasonPopup}
    />,
    highlights: <HighLightsTab
      getHighlights={getHighlights}
      flag={apiCheck}
      listView={isListView}
      groupName={topPeople?.groupName}
    />,
  };
  useEffect(() => {
    const navArrayTemp = [];

    navArrayTemp.push('Members');

    if (highlights?.articles && highlights.articles.length > 1) {
      navArrayTemp.push('Highlights');
    }
    setNavArray(navArrayTemp);
  }, [highlights?.articles]);

  const isVisible = () => {
    setVisible(!visible);
  };

  const deleteGroup = () => {
    setPopupRemoveClicked(true);
    setPopupVisible(false);
    dispatch(actions.setPersonRemoved(false));
    if (groupId) {
      dispatch(groupActions.deleteGroup({ groupId: groupIdParsed }));
    }
  };

  const shareGroupHandler = (check: boolean) => {
    if (check) {
      dispatch(groupActions.setSelectedGroups([{ name: topPeople?.groupName || '', id: groupIdParsed }]));
    }
  };

  useEffect(() => {
    if (groupShared) {
      dispatch(groupActions.setSelectedGroups([]));
    }
  }, [groupShared]);

  useEffect(() => {
    if (!topPeopleLoading) {
      dispatch(certificationActions.certificationAction({
        type: 'buyer_navigate',
        source: 'buyer',
        data,
      }));
      dispatch(certificationActions.certificationAction({
        type: 'buyer_group',
        source: 'buyer',
        data,
      }));
    }
    if (visible) {
      dispatch(certificationActions.certificationAction({
        type: 'category_change',
        source: 'buyer',
        data,
      }));
    }
  }, [topPeopleLoading, visible]);

  useEffect(() => {
    if (isScroll && scrollToPage.includes('/groupdetails/')) {
      certificationSmoothBehavior(scrollToId);
      dispatch(certificationActions.setIsScroll(false));
    }
  }, [scrollToId, isScroll]);

  useEffect(() => {
    if (!isHighlighted && !isScroll && currentType === 'buyer_navigate') {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType]);

  useEffect(() => {
    if (isToaster && !highlightsLoading && data.groupId === groupIdParsed
      && navArray.length < 2
      && !highlights?.articles?.length
      && currentType === 'buyer_navigate') {
      dispatch(flurryActions.setNotification({
        message: GROUP_TOASTER,
        proTip: true,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
        certification: true,
        type: 'group',
      }));
      if (toasterFlag) {
        dispatch(certificationActions.setToasterFlag(false));
      }
    } else {
      dispatch(flurryActions.setNotification({
        message: '',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  }, [data, currentType, highlightsLoading, groupIdParsed, membersLoading, isToaster]);

  useEffect(() => {
    if (data.groupId !== groupIdParsed) {
      notification.destroy();
    }
  }, [groupIdParsed]);

  useEffect(
    () => () => {
      dispatch(flurryActions.setNotification({
        message: '',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
      notification.destroy();
    },
    [],
  );

  useEffect(() => {
    setIsToaster(toasterFlag);
  }, [toasterFlag]);
  const handleExport = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('buyer_group_export', 0, {
        ...flurryObject,
        ...isCalled && { isCalled },
        groupId: groupIdParsed,
        host,
      }),
    ));
    dispatch(groupActions.exportGroupMembers({
      groupId: groupIdParsed,
      filters: `${filtersFromRedux.filter((item) => item.isSelected).map((item) => item.filterId).join(',')}`,
    }));
  };

  const TagGroup: TagItem = {
    type: 'group',
    id: groupIdParsed,
    name: topPeople?.groupName,
    image: DEFAULT_GROUP_GILROY_IMAGE,
    color: '',
  };

  useEffect(() => {
    if (topPeople?.groupId) {
      dispatch(certificationActions.aiCertificationAction({
        type: 'open_buyer_group',
        source: 'group_gilroy',
        data: aiCertificationData,
      }));
    }
  }, [topPeople]);

  useEffect(() => {
    if (topPeople?.groupId) {
      dispatch(certificationActions.aiCertificationAction({
        type: 'open_buyer_group',
        source: 'group_gilroy',
        data: aiCertificationData,
      }));
    }
  }, [topPeople]);

  // useEffect(() => {
  //   dispatch(buyerGroupsActions.getShowGroupNotesRequest({
  //     groupId: groupIdParsed,
  //   }));
  // }, []);

  const showGilroy = () => chatbotAllowed && allowGlobalGilroy && TagGroup?.name?.length
    && topPeople?.groupId === groupId;

  const handleMergeClick = () => {
    dispatch(groupActions.setGroupDrawerOpen(true));
    dispatch(groupActions.setIsMerge(groupIdParsed));
  };

  const handleAnalyzeBuyersClick = () => {
    dispatch(buyerGroupsActions.setAnalyzeBuyer(true));
    dispatch(UiAction.isShowGilroyGlobalToggle(true));
  };

  return (
    <Wrapper className={classNames('p-relative select-highlight-none', { layerActive: isPersonDrag })}>
      <OverlayLayer className={classNames({ show: isPersonDrag })} />
      <NavBarPrimary headerClassName={classNames(
        'headers-space box-shadow no-overflow-on-header',
        { indexZero: isHighlight && currentType !== 'buyer_navigate' && !topPeople?.data.length },
      )}
      >
        <div className="left-side-wrap text-truncate-one-line">
          <BackIcon onClick={() => {
            if (showGilroyGlobal) {
              dispatch(UiAction.isShowGilroyGlobalToggle(false));
            } else {
              navigate(-1);
            }
          }}
          />
          {topPeopleLoading ? (
            <SkeletonCustom
              height="30px"
              width="400px"
              margin="0px"
            />
          )
            : showStickyNav ? (
              <h1 className="heading text-truncate-two-line">{topPeople?.groupName}</h1>
            ) : (
              <h1 className="heading text-truncate-two-line">Buyer Group</h1>
            )}
        </div>
        <div className="right-side-wrap c-pointer">
          {isTab ? null : (
            <div className={`${isGlobalSearchOpen ? 'hideTabs' : 'showTabs'}`}>
              {showStickyNav && !isCompanyDetailsInView
                && (
                  <div className={classNames(
                    'tips-placeholder buyersTips',
                    {
                      highlightActive: pathname.includes(HIGHLIGHTS),
                      membersActive: pathname.includes(MEMBERS),
                    },
                  )}
                  >
                    <FeedTabs baseComponentPath="groupdetails" tabsName={navArray} elementTarget="tabs-details" headerAppendTab />
                  </div>
                )}
            </div>
          )}
          {
            !isTab && showStickyNav ? (
              <div className={`editControlInHeaderWrapper ${isGlobalSearchOpen ? 'hideTabs' : 'showTabs'}`}>
                {editClicked
                  ? (
                    <Button
                      className="btnCancel tabs-item cancel-icon-mode d-flex justify-content-center align-items-center radius-50"
                      disabled={removeClicked}
                      onClick={() => {
                        setRemovedPeople([]);
                        setRemovedGrpPeople([]);
                        setEditClicked(false);
                      }}
                      aria-label="Cancel"
                    >
                      {isTab ? (
                        <Cross />
                      ) : (
                        <span>Cancel</span>
                      )}
                    </Button>
                  ) : null}
                {
                  membersCount ? (
                    <Button
                      className="btnEditDelete tabs-item d-flex svg-style edit-tab justify-content-center align-items-center"
                      onClick={handleEditClick}
                      aria-label={editClicked ? 'Delete' : 'Edit'}
                      disabled={(editClicked && !removedPeople.length) || removeClicked}
                    >
                      {
                        editClicked ? <DeleteIcon /> : <PencilIcon />
                      }
                      {!isTab && (
                        <span style={{
                          marginLeft: '10px',
                          marginRight: '8px',
                        }}
                        >
                          {getButtonLabel()}
                        </span>
                      )}
                    </Button>
                  ) : null
                }
              </div>
            ) : null
          }
          {
            section === 'members' && !disclessPersonality && showStickyNav && !isCompanyDetailsInView && !isTab ? (
              <div className={`${isGlobalSearchOpen ? 'hideTabs' : 'showTabs'}`}>
                <FilterPopOver
                  filters={filters}
                  loading={false}
                  selectAll={selectAll}
                  onChangeFilters={onChangeFilters}
                  onClickHandler={onClickHandler}
                  applyFilterHandler={applyFilterHandler}
                  disableApplyBtn={checkForApplyFilter()}
                  iconMode
                />
              </div>
            ) : <div />
          }
          <GlobalSearch
            iconMode={isTab || (showStickyNav && !isCompanyDetailsInView)}
            groupId={groupIdParsed}
          />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      {showGilroy() ? (
        <div className="container chatbot-container">
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} tagItem={TagGroup} />
        </div>
      ) : null}
      <div className="container">
        <div className="sub-navbar-group-detail d-flex align-items-center justify-content-between">
          {
            topPeopleLoading ? (
              <SkeletonCustom
                height="30px"
                width="200px"
                smWidth="100px"
              />
            ) : (
              <div className="sub-navbar-left-side d-flex align-items-center group-details-pills">
                <Title
                  groupId={groupIdParsed}
                  title={topPeople?.groupName}
                  Icon={<PeopleIcon />}
                  isEditable={topPeople?.groupShared === 0}
                  onEdit={handleTitleEdit}
                  disableEditForce={titleUpdateLoadingForce || disableEditLocal}
                  onDisableEditForceComplete={() => {
                    if (disableEditLocal) setDisableEditLocal(false);
                    if (titleUpdateLoadingForce) dispatch(actions.titleUpdateLoadingForce(false));
                  }}
                />
                {topPeople?.groupShared === 1 ? <SharedBadge label={`Shared by ${topPeople?.sharedByFirstName || ''}`} /> : null}
              </div>
            )
          }
          <div className="sub-navbar-right-side share-drawer-div">
            <div className="d-flex align-items-center">
              {!isFreeUser()
                && (
                  <ShareGroupPeopleModal
                    onClickHandler={() => shareGroupHandler(true)}
                    onCancelHandler={() => shareGroupHandler(false)}
                    iconMode
                    isDetailPage
                  />
                )}
              {
                !isFreeUser()
                && (
                  <>
                    {
                      isMob ?
                        <MergeMobileBtn onClick={handleMergeClick}>
                          <MergeGroupIcon />
                        </MergeMobileBtn>
                        :
                        <GlobalButton
                          title="Merge Groups"
                          bgColor={primaryColor}
                          textColor="#fff"
                          onButtonClick={handleMergeClick}
                          fontSize="12px"
                          fontSizeSm="12px"
                          PaddingSm="7px 15px 7px"
                          innerSpace="8px 15px 7px"
                        />
                    }
                  </>
                )
              }
              {/* Analyze Buyers Button */}
              {
                !isFreeUser()
                && (
                  <>
                    {
                      isMob ?
                        <MergeMobileBtn onClick={handleAnalyzeBuyersClick}>
                          <AnalyzeBuyersIcon />
                        </MergeMobileBtn>
                        :
                        <GlobalButton
                          title="Analyze Buyers"
                          bgColor={SecondaryColor}
                          textColor="#fff"
                          onButtonClick={handleAnalyzeBuyersClick}
                          fontSize="12px"
                          fontSizeSm="12px"
                          PaddingSm="7px 15px 7px"
                          innerSpace="8px 15px 7px"
                        />
                    }
                  </>
                )
              }
              <DrawerPeopleBrowse
                key="peopleBrowse"
                groupId={groupIdParsed}
                showDrawer={drawerToggle !== previousToggle
                  && !(anyValueInKeyOfArrayExists(filters, 'isSelected', false) || searchString.length > 0)}
              />
            </div>
          </div>
        </div>
        <DrawerPeopleGroup
          key="groupBrowse"
          openNewCreate={openCreateModal}
          setOpenNew={toggle}
          showNew={showNew}
          toggleShowNew={(bool: boolean) => setShowNew(bool)}
          noButton
          drag={drag}
        />
        <TabsWrapper className="tabs-placeholder" id="certification-buyer-groups">
          <Row className="w-100 filter-tabs-heading-row justify-content-between" gutter={8}>
            <div className="headingContent">
              <div className="head-wrap">
                {pathname.includes(HIGHLIGHTS) ? 'Highlights' : (
                  <span className="heading-div">
                    Members
                    {' '}
                    <span className={`count ${translateSkipAreas}`}>
                      (
                      {formattedMembersCount}
                      )
                    </span>
                  </span>
                )}

                {(pathname.includes(HIGHLIGHTS) || isTab) ? <span /> : (
                  <span className="layerAppend text-truncate">
                    <span>Drag and Drop</span>
                    {' '}
                    <span className="green">Members</span>
                  </span>
                )}
              </div>
            </div>
            {!isMob && (
              <div className="feed-tabs-div">
                <Waypoint
                  onEnter={() => setShowStickyNav(false)}
                  onLeave={() => setShowStickyNav(true)}
                  topOffset={100}
                >
                  <div className={classNames(
                    'tips-placeholder buyersTips',
                    {
                      highlightActive: pathname.includes(HIGHLIGHTS),
                      membersActive: pathname.includes(MEMBERS),
                      highlightedComponent: isHighlight && currentType === 'buyer_navigate',
                      downloadProfileBtn: isHighlight && currentType === 'buyer_navigate',
                    },
                  )}
                  >
                    <FeedTabs baseComponentPath="groupdetails" tabsName={navArray} elementTarget="tabs-details" headerAppendTab />
                  </div>
                </Waypoint>
              </div>
            )}
            <div className={classNames('d-flex justify-content-end mr-0 pr-0 tablet-col-search', { showOnlyMembersHere: getMembersTab })}>
              {
                section === 'members' ? (
                  <div className="filter-placeholder d-flex search-responsive tabs-wrapper group-detail-large-mode-fix other-div">
                    {
                      membersCount ? (
                        <Button
                          className="tabs-item d-flex svg-style edit-tab justify-content-center align-items-center"
                          onClick={handleEditClick}
                          aria-label={editClicked ? 'Delete' : 'Edit'}
                          disabled={(editClicked && !removedPeople.length) || removeClicked}
                        >
                          {
                            isTab && (editClicked ? <DeleteIcon /> : <PencilIcon />)
                          }
                          {!isTab && (
                            <span style={{
                              marginLeft: '8px',
                              marginRight: '8px',
                            }}
                            >
                              {getButtonLabel()}
                            </span>
                          )}
                        </Button>
                      ) : null
                    }
                    {
                      editClicked ? (
                        <Button
                          className="tabs-item cancel-icon-mode d-flex justify-content-center align-items-center radius-50"
                          disabled={removeClicked}
                          onClick={() => {
                            setRemovedPeople([]);
                            setRemovedGrpPeople([]);
                            setEditClicked(false);
                          }}
                          aria-label="Cancel"
                        >
                          {isTab ? (
                            <Cross />
                          ) : (
                            <span>Cancel</span>
                          )}
                        </Button>
                      ) : null
                    }
                    {/* {showGroupNotes && ( */}
                    <DrawerPeopleMoveReason
                      isBuyerGroupNotes
                    />
                    {/* )} */}
                    {
                      !disclessPersonality && !showStickyNav && (
                        <div className={classNames('filterPeopleGroup', { isEditEnable: editClicked })}>
                          <FilterPopOver
                            filters={filters}
                            loading={false}
                            selectAll={selectAll}
                            onChangeFilters={onChangeFilters}
                            onClickHandler={onClickHandler}
                            applyFilterHandler={applyFilterHandler}
                            disableApplyBtn={checkForApplyFilter()}
                            iconMode={isTab}
                          />
                        </div>
                      )

                    }
                    <div className="export-people">
                      <GlobalButton
                        textColor="#7E7E7E"
                        bgColor="#fff"
                        outlineColor="#DADADA"
                        innerSpace="6px 15px 6px 15px"
                        LeftSpace="7px"
                        IconLeft={<ExportIcon />}
                        buttonClassName="share-button mr-24 export_btn"
                        rightSeparatorClassName="right-separator-class"
                        onButtonClick={handleExport}
                        disabled={membersCount === 0}
                      />
                    </div>
                  </div>
                ) : <div className="filter-placeholder d-flex" />
              }
            </div>
          </Row>
        </TabsWrapper>

        {isMob && (
          <Col className="feed-tabs-div w-100 d-flex justify-content-center">
            <Waypoint
              onEnter={() => setShowStickyNav(false)}
              onLeave={() => setShowStickyNav(true)}
              topOffset={100}
            >
              <div className={classNames(
                'tips-placeholder buyersTips',
                {
                  highlightActive: pathname.includes(HIGHLIGHTS),
                  membersActive: pathname.includes(MEMBERS),
                  highlightedComponent: isHighlight && currentType === 'buyer_navigate',
                  downloadProfileBtn: isHighlight && currentType === 'buyer_navigate',
                },
              )}
              >
                <FeedTabs baseComponentPath="groupdetails" tabsName={navArray} elementTarget="tabs-details" headerAppendTab />
              </div>
            </Waypoint>
          </Col>
        )}
        <div
          className="tabSection"
        >
          <div>{tabs[section?.toLowerCase() || 'members']}</div>
        </div>
        <AddReasonPopup
          visible={visible}
          setVisible={isVisible}
          categoryNext={categoryNext}
          categoryPrev={categoryPrev}
          stageNext={stageNext}
          stagePrev={stagePrev}
          handleChangeCategory={handleChangeCategory}
        />
      </div>
      <CustomModal
        visible={popupVisible}
        onOk={deleteGroup}
        onCancel={openDrawer}
        centered
        cancelText="Save"
        okText="Remove"
        closeIcon={<CrossCircle />}
        width="582px"
        className="logout-modal-c"
        maskClosable={false}
      >
        <span className="heading_logout_popup">There are no people in the buyer group, do you want to remove the buyer group?</span>
      </CustomModal>
    </Wrapper>
  );
};

export default PeopleGroupDetail;